import { Button, Checkbox, Col, ConfigProvider, Radio, RadioChangeEvent, Row, Space } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/store/storehooks";
import { getLabList, getParsicUser, getVoipReports, setVoipReports } from "../../../api/api";
import { UpdateParsicUsers } from "../../../redux/reducers/parsicUsersSlice";
import { errorNotify, errorNotifyByErrorObject, sucessNotify } from "../../../services/toast.notification";
import jalali_moment from 'jalali-moment';
import moment from 'moment'
import { DatePicker as DatePickerJalali, JalaliLocaleListener } from "antd-jalali";
import CustomTable from "../../../components/_common/Table";
import fa_IR from "antd/lib/locale/fa_IR";
import Spinner from "../../../components/_common/Spinner";
import CustomSelect from "../../../components/_common/CustomSelect";
import CustomTextArea from "../../../components/_common/CustomTextArea";
import { UpdateLabList } from "../../../redux/reducers/lablistSlice";
import "./style.css";
import "../voipManagment/style.css"

const VoipReportManagment = () => {
    const columns: ColumnsType<any> = [
        { title: 'آزمایشگاه ', dataIndex: 'str_LabPersianName', key: 'str_LabPersianName' },
        { title: 'استان ', dataIndex: 'stateName', key: 'stateName' },
        { title: 'دسته بندی', dataIndex: 'typeProblems', key: 'typeProblems' },
        { title: 'تاریخ تماس ', dataIndex: 'callDate', key: 'callDate' },
        { title: 'شماره تماس', dataIndex: 'str_CallNumber', key: 'str_CallNumber' },
        { title: 'توضیحات مشکل پیش آمده', dataIndex: 'str_Problems', key: 'str_Problems	' },
        {
            title: 'حل شد',
            dataIndex: 'bit_Solved',
            key: 'bit_Solved',
            render: (value) => (
                <Checkbox checked={Boolean(value)} disabled />
            ),
        },
        { title: 'مدت زمان پاسخگویی', dataIndex: 'str_DurationPerformance', key: 'str_DurationPerformance' },
        {
            title: 'ارجاع',
            dataIndex: 'bit_referral',
            key: 'bit_referral',
            render: (value) => (
                <Checkbox checked={value == "1"} disabled />
            ),
        }, { title: 'ارجاع به', dataIndex: 'reciver', key: 'reciver' },
        { title: 'دلیل ارجاع', dataIndex: 'str_referral', key: 'str_referral' },
        {
            title: 'نیاز به تماس مجدد',
            dataIndex: 'bit_callAgain',
            key: 'bit_callAgain',
            render: (value) => (
                <Checkbox checked={Boolean(value)} disabled />
            ),
        },
        { title: 'امتیاز ', dataIndex: 'int_Score', key: 'int_Score' },
        { title: 'امتیاز ارجاعی ', dataIndex: 'int_referralScore', key: 'int_referralScore' },
        {
            title: 'تایید شد',
            dataIndex: 'bit_Confirm',
            key: 'bit_Confirm',
            render: (value) => (
                <Checkbox checked={Boolean(value)} disabled />
            ),
        },
        { title: 'توضیحات اضافی', dataIndex: 'str_Desc', key: 'str_Desc' },
        {
            title: '', dataIndex: 'Action', key: 'Action', render: (_, record) => (
                <Space size="middle">
                    <Button type="primary" style={{ backgroundColor: "orange" }}
                        onClick={() =>
                            OpenModal(record)}>  جزییات</Button>
                </Space>
            )
        }
    ];

    const [isLoading, setIsLoading] = useState(false);
    const [permission, setPermission] = useState(false);
    const [userList, setUserList] = useState<any[]>([]);
    const [radioVal, setRadioVal] = useState(0);
    const [voipLogs, setVoipLogs] = useState([]);
    const [firstDate, setFirstDate] = useState<any>(undefined);
    const [lastDate, setLastDate] = useState<any>(undefined);
    const [selectedExten, setSelectedExten] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [voipReportList, setVoipReportList] = useState([]);
    const [selectedRecord, setSelectedRecord] = useState<any>(undefined);
    const [isSolve, setIsSolve] = useState(false);
    const [isReferral, setIsReferral] = useState(false);
    const [isCallAgain, setIsCallAgain] = useState(false);
    const [isConfirms, setIsConfirms] = useState(false);
    const [reportList, setreportList] = useState<any[]>([]);
    const [selectedLab, setSelectedLab] = useState(0);
    const [labList, setLabList] = useState<any[]>([]);
    const [isShowDetail, setIsShowDetail] = useState(false);

    const [inputValues, setInputValue] = useState({
        id: 0,
        mode: 1,
        problems: "",
        solve: true,
        type: 0,
        confirms: true,
        desc: "",
        userId: 0,
        callNumber: "",
        durationPerformance: '',
        referral: true,
        strreferral: "",
        callAgain: true,
        labId: 0,
        reciver: '',
        referralScore: '',
        score: '',
        callDate: ""
    });

    const problemTypes = [
        {
            title: "سنترال",
            value: 1
        },
        {
            title: "وب و شبکه",
            value: 2
        },
        {
            title: "ژورنال و دستگاه",
            value: 3
        },
        {
            title: "سایر",
            value: 4
        }]
    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();

    const _getParsicUser = () => {
        setIsLoading(true);
        getParsicUser()
            .then((result: any) => {
                dispatch(UpdateParsicUsers({ parsicUsers: result.data.data }))
                setUserList(result.data.data)
                setIsLoading(false);
            })
            .catch((error: any) => {
                console.log(error);
                errorNotifyByErrorObject(error, undefined, 5000)
            })
    }

    const onChangeRadio = (e: RadioChangeEvent) => {
        setIsLoading(true);
        setRadioVal(e.target.value);
        _getVoipVReport(firstDate != undefined ? jalali_moment.from(firstDate.format('YYYY/MM/DD'), 'fa', 'YYYY-M-D')
            .format('YYYY/MM/DD') : moment().format("YYYY/MM/DD"), lastDate != undefined ? jalali_moment.from(lastDate.format('YYYY/MM/DD'), 'fa', 'YYYY-M-D')
                .format('YYYY/MM/DD') : moment().format("YYYY/MM/DD"), e.target.value, selectedLab);
        setSelectedExten(e.target.value);
    }

    const onChangeDatePicker = (dates: any, dateStrings: any, info: any) => {

        console.log(dates);
        if (!dateStrings) return;
        if (dateStrings.length < 2) return;
        if (dateStrings[0] === "") return;
        if (dateStrings[1] === "") return;

        setFirstDate(dates[0])
        setLastDate(dates[1])

        let fdate = jalali_moment.from(dates[0].format('YYYY/MM/DD'), 'fa', 'YYYY-M-D')
            .format('YYYY/MM/DD');
        let ldate = jalali_moment.from(dates[1].format('YYYY/MM/DD'), 'fa', 'YYYY-M-D')
            .format('YYYY/MM/DD');

        _getVoipVReport(fdate, ldate, selectedExten, selectedLab);

    }

    const addNewReport = () => {
        let obj: any = myStore.parsicUsers.list.find((x: any) => x.int_VoipExtension == Number(selectedExten));
        let newReport: any =
        {
            "id": inputValues.id,
            "mode": 1,
            "problems": inputValues.problems,
            "solve": isSolve,
            "type": inputValues.type ? Number(inputValues.type) : 1,
            "confirms": isConfirms,
            "desc": inputValues.desc,
            "userId": inputValues.userId,
            "callNumber": inputValues.callNumber,
            "durationPerformance": inputValues.durationPerformance != "" ? Number(inputValues.durationPerformance) : 0,
            "referral": isReferral,
            "strreferral": inputValues.strreferral,
            "callAgain": isCallAgain,
            "labId": inputValues.labId,
            "reciver": inputValues.reciver ? Number(inputValues.reciver) : 0,
            "referralScore": inputValues.referralScore != "" ? inputValues.referralScore : 0,
            "score": inputValues.score != "" ? inputValues.score : 0,
            "callDate": jalali_moment.from(inputValues.callDate, 'fa', 'YYYY/M/D').format('YYYY/M/D')
        };
        const updatedList = [...reportList, newReport];
        setreportList(updatedList);
        return updatedList;
    }

    const _editVoipVReport = () => {
        var updatedList = addNewReport();

        setVoipReports(updatedList)
            .then((result: any) => {
                sucessNotify("ثبت شد");
                CloseModal();
                _getVoipVReport(firstDate != undefined ? jalali_moment.from(firstDate.format('YYYY/MM/DD'), 'fa', 'YYYY-M-D')
            .format('YYYY/MM/DD') : moment().format("YYYY/MM/DD"), lastDate != undefined ? jalali_moment.from(lastDate.format('YYYY/MM/DD'), 'fa', 'YYYY-M-D')
                .format('YYYY/MM/DD') : moment().format("YYYY/MM/DD"), selectedExten, selectedLab);
            })
            .catch((error: any) => {
                console.log(error);
                errorNotifyByErrorObject(error, undefined, 5000)
            });
    }

    const _getVoipVReport = (fdate: any, ldate: any, exten: any, labId: any) => {
        setVoipReportList([]);
        let obj: any = myStore.parsicUsers.list.find((x: any) => x.int_VoipExtension == Number(exten));

        setIsLoading(true);
        getVoipReports(labId, obj.prk_ParsicUser_AutoID, fdate, ldate)
            .then((result: any) => {
                if (result.data.data.length > 0) {
                    //let jsonResult = JSON.parse(result.data.data);
                    setVoipReportList(result.data.data);
                }
                setIsLoading(false)
            });
    }

    const CloseModal = () => {
        setShowModal(false);
    }

    const OpenModal = (record: any) => {
        setSelectedRecord(record);
        setInputValue({
            id: record.prk_VoipVLabProblems,
            mode: 1,
            problems: record.str_Problems,
            solve: record.bit_Solved,
            type: problemTypes.find(a => a.title === record.typeProblems)?.value ?? 1,
            confirms: record.bit_Confirm,
            desc: record.str_Desc,
            userId: myStore.parsicUsers.list.find((x: any) => x.str_FullName == record.responsive)?.prk_ParsicUser_AutoID ?? 0,
            callNumber: record.str_CallNumber,
            durationPerformance: record.str_DurationPerformance,
            referral: record.bit_referral == "1" ? true : false,
            strreferral: record.str_referral,
            callAgain: record.bit_callAgain,
            labId: labList.find((x: any) => x.str_LabPersianName == record.str_LabPersianName)?.prk_AndriodLab_AutoID ?? 0,
            reciver: myStore.parsicUsers.list.find((x: any) => x.str_FullName == record.reciver)?.prk_ParsicUser_AutoID ?? 0,
            referralScore: record.int_referralScore,
            score: record.int_Score,
            callDate: record.callDate
        });

        setIsSolve(record.bit_Solved);
        setIsConfirms(record.bit_Confirm);
        setIsReferral(record.bit_referral == "1" ? true : false);
        setIsCallAgain(record.bit_callAgain);

        setShowModal(true);
    }

    const handleChange = (event: any) => {
        if (event.target.name == 'isSolve') {
            if (event.target.checked) {
                setIsSolve(event.target.checked);
            }
            else {
                setIsSolve(false);
            }

        }

        if (event.target.name == 'isReferral') {
            if (event.target.checked) {
                setIsReferral(event.target.checked);
            }
            else {
                setIsReferral(false);
            }

        }

        if (event.target.name == 'isCallAgain') {
            if (event.target.checked) {
                setIsCallAgain(event.target.checked);
            }
            else {
                setIsCallAgain(false);
            }

        }

        if (event.target.name == 'isConfirms') {
            if (event.target.checked) {
                setIsConfirms(event.target.checked);
            }
            else {
                setIsConfirms(false);
            }

        }

        else {

            const { name, value } = event.target;
            setInputValue({ ...inputValues, [name]: value });

        }
    }

    useEffect(() => {
        if (myStore.auth.loginType === 'parsicuser') {
            if (myStore.auth.manager === true)
                setPermission(true);
            else
                setPermission(false);

            myStore.auth.permission.map((item: any) => {
                if (item.pageName == 'voipManagementReport') {
                    if (item.isDetailAccess) {
                        setIsShowDetail(true)
                        _getLabList();
                    }
                    else
                        setIsShowDetail(false)
                }

            });
        }



    }, []);


    const _getLabList = () => {
        setIsLoading(true);
        getLabList()
            .then((result: any) => {
                dispatch(UpdateLabList({ labList: result.data.data }))
                var list: any = [];
                list.push({ prk_AndriodLab_AutoID: 0, str_LabPersianName: 'همه' });

                result.data.data.map((item: any) => {
                    list.push({ prk_AndriodLab_AutoID: item.prk_AndriodLab_AutoID, str_LabPersianName: item.str_LabPersianName })
                })

                setLabList(list);
                _getParsicUser();

                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })

    }

    const labChange = (event: any) => {
        setSelectedLab(event.target.value);
        _getVoipVReport(firstDate != undefined ? jalali_moment.from(firstDate.format('YYYY/MM/DD'), 'fa', 'YYYY-M-D')
            .format('YYYY/MM/DD') : moment().format("YYYY/MM/DD"), lastDate != undefined ? jalali_moment.from(lastDate.format('YYYY/MM/DD'), 'fa', 'YYYY-M-D')
                .format('YYYY/MM/DD') : moment().format("YYYY/MM/DD"), selectedExten, event.target.value);
    }


    return (<>
        {!isShowDetail &&
            (
                <div className="alert-box">
                    متاسفانه شما به محتوای این صفحه دسترسی ندارید!
                </div>
            )}
        {
            isLoading === false && isShowDetail && (
                <div>
                    <Row>
                        <Col lg={6} md={6} sm={24} xs={24}>
                            <CustomSelect
                                name="labId"
                                placeholder="آزمایشگاه"
                                itemList={labList}
                                value={selectedLab.toString()}
                                onChange={labChange}
                                valueObjectField={"prk_AndriodLab_AutoID"}
                                displayObjectField={"str_LabPersianName"}
                            />
                            <div className="col-shadow">
                                <Radio.Group
                                    style={{ marginTop: '15px' }}
                                    onChange={onChangeRadio} value={radioVal}>
                                    {myStore.parsicUsers.list && myStore.parsicUsers.list.map((item: any) => {
                                        if (item.int_VoipExtension != 0) {
                                            return (
                                                <div>
                                                    <Radio value={item.int_VoipExtension}>{item.str_FullName}</Radio>
                                                </div>)
                                        }
                                    })}
                                </Radio.Group>
                            </div>
                        </Col>
                        <Col lg={18} md={18} sm={24} xs={24}>
                            <div className="viop-content">
                                {selectedExten !== 0 && (<div className="calender">
                                    <ConfigProvider locale={fa_IR} direction="rtl">
                                        <JalaliLocaleListener />
                                        <DatePickerJalali.RangePicker value={[firstDate, lastDate]} onCalendarChange={(dates: any, dateStrings: any, info: any) => onChangeDatePicker(dates, dateStrings, info)} />
                                    </ConfigProvider>
                                </div>
                                )
                                }
                                <Row>
                                    <CustomTable columns={columns} data={voipReportList} isloading={isLoading}
                                        permission={permission} />
                                </Row>
                            </div>
                        </Col>

                    </Row>
                </div>
            )
        }
        {
            isLoading === true && (
                <Spinner />
            )
        }

        {showModal && (
            <div className="personnel-modal-backdrop">
                <div className="personnel-modal-content">
                    <div className="personnel-modal-header">
                        <h5 style={{ fontSize: '20px' }}>  تایید گزارش</h5>
                        <button onClick={CloseModal} className="personnel-close-button">&times;</button>
                    </div>
                    <div className="personnel-modal-body">
                        <Row>
                            <Col lg={12} md={12} sm={24} xs={24}>

                                <CustomSelect
                                    name="type"
                                    placeholder="دسته بندی"
                                    itemList={problemTypes}
                                    value={inputValues.type.toString() || ""}
                                    onChange={(e) => handleChange(e)}
                                    valueObjectField={"value"}
                                    displayObjectField={"title"}
                                />
                            </Col>
                            <Col lg={12} md={12} sm={24} xs={24}>

                                <CustomTextArea
                                    name="durationPerformance"
                                    placeholder="مدت زمان حل مشکل"
                                    value={inputValues.durationPerformance || ""}
                                    onChange={handleChange}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <CustomTextArea
                                name="problems"
                                placeholder="توضیحات مشکل پیش آمده"
                                value={inputValues.problems || ""}
                                onChange={handleChange}
                            />
                        </Row>
                        <Row>
                            <CustomTextArea
                                name="desc"
                                placeholder="توضیحات اضافی"
                                value={inputValues.desc || ""}
                                onChange={handleChange}
                            />
                        </Row>
                        <Row style={{ margin: '15px 0px' }}>
                            <Col lg={12} md={12} sm={24} xs={24}>
                                <Checkbox
                                    name="isSolve"
                                    onChange={(e) => handleChange(e)}
                                    checked={isSolve}
                                >
                                    {"مشکل حل شد"}
                                </Checkbox>

                            </Col>
                            <Col lg={12} md={12} sm={24} xs={24}>
                                <Checkbox
                                    name="isReferral"
                                    onChange={(e) => handleChange(e)}
                                    checked={isReferral}
                                >
                                    {"ارجاع"}
                                </Checkbox>
                            </Col>
                        </Row>
                        {isReferral &&
                            <Row>
                                <Col lg={12} md={12} sm={24} xs={24}>

                                    <CustomSelect
                                        name="reciver"
                                        placeholder="ارجاع به"
                                        itemList={myStore.parsicUsers.list}
                                        value={inputValues.reciver}
                                        onChange={(e) => handleChange(e)}

                                        valueObjectField={"prk_ParsicUser_AutoID"}
                                        displayObjectField={"str_FullName"}
                                    />
                                </Col>
                                <Col lg={12} md={12} sm={24} xs={24}>

                                    <CustomTextArea
                                        name="strreferral"
                                        placeholder="دلیل ارجاع"
                                        value={inputValues.strreferral || ""}
                                        onChange={handleChange}
                                    />
                                </Col>
                            </Row>
                        }
                        <Row>
                            <Col lg={12} md={12} sm={24} xs={24}>
                                <CustomTextArea
                                    name="score"
                                    disabled={!permission}
                                    placeholder="امتیاز"
                                    value={inputValues.score || ""}
                                    onChange={handleChange}
                                />
                            </Col>
                            <Col lg={12} md={12} sm={24} xs={24}>
                                <CustomTextArea
                                    name="referralScore"
                                    disabled={!permission}
                                    placeholder="امتیاز ارجاع"
                                    value={inputValues.referralScore || ""}
                                    onChange={handleChange}
                                />
                            </Col>
                        </Row>
                        <Row style={{ margin: '15px 0px' }}>
                            <Col lg={12} md={12} sm={24} xs={24}>
                                <Checkbox
                                    name="isCallAgain"
                                    onChange={(e) => handleChange(e)}
                                    checked={isCallAgain}
                                >
                                    {"نیاز به تماس مجدد"}
                                </Checkbox>
                            </Col>
                            <Col lg={12} md={12} sm={24} xs={24}>
                                <Checkbox
                                    name="isConfirms"
                                    disabled={!permission}
                                    onChange={(e) => handleChange(e)}
                                    checked={isConfirms}
                                >
                                    {"تایید شد"}
                                </Checkbox>
                            </Col>
                        </Row>
                    </div>
                    <div className="personnel-modal-footer">
                        <button className="btn btn-success" onClick={_editVoipVReport}>ثبت</button>
                        <button className="btn btn-danger" onClick={CloseModal}>انصراف</button>
                    </div>
                </div>
            </div>
        )}
    </>)

}

export default VoipReportManagment;